import { useMemo } from 'react';
import useConfig from 'hooks/useConfig';
import { SECTIONS } from 'constant';
import useAuth from './useAuth';
import { ONBOARDING_PATH } from 'config';

function useRouteGuard() {
    let { user, hasOnboarded, isReady, isEligibleForKYC, kycLoaded, hasOnDemand } = useAuth();
    let { enabled_sections } = useConfig();
    let enabled = (enabled_sections || []).map((item) => item.key);

    let enabledPaths = useMemo(() => {
        if (!hasOnboarded) {
            return SECTIONS.Onboarding;
        }
        let allowed = Object.keys(SECTIONS.PathToSections).filter((path) => {
            let pathSections = SECTIONS.PathToSections[path] || [];
            return pathSections.some((section) => enabled.includes(section));
        });

        if (hasOnboarded && user?.onboarding?.allow_multiple_onboardings) {
            allowed.push(ONBOARDING_PATH);
        }

        if (user && isReady && kycLoaded) {
            allowed = allowed.filter((s) => s !== '/kyc');
            const showKycSection =
                (user?.has_funded_accounts && user?.type === 'customer' && isEligibleForKYC) ||
                user?.kyc_status === 'approved' ||
                hasOnDemand;
            if (showKycSection) {
                allowed.push('/kyc');
            }
        }
        return [...SECTIONS.AlwaysAvailable, ...allowed];
    }, [enabled_sections, isReady, hasOnboarded, kycLoaded, isEligibleForKYC, user]);
    return enabledPaths;
}

export default useRouteGuard;

export const PathIsEnabled = (path: string) => {
    const enabledPaths = useRouteGuard();
    return enabledPaths.indexOf(path) !== -1;
};
